/** Interface strings of the payment channels beyond Telegram Stars (ADR 0238). */
export const billingMessages = {
  "billing.sbp.entry": { ru: "Оплатить через СБП", en: "Pay by SBP" },
  "billing.sbp.chooserTitle": {
    ru: "Что оплатить через СБП",
    en: "What to pay for by SBP",
  },
  "billing.sbp.cancel": { ru: "Отмена", en: "Cancel" },
  "billing.sbp.processing": {
    ru: "Платёж обрабатывается. Как только он подтвердится, мы напишем вам в чат.",
    en: "The payment is being processed. We will message you in the chat once it is confirmed.",
  },
  "billing.sbp.paid": {
    ru: "Оплата подтверждена. Спасибо!",
    en: "Payment confirmed. Thank you!",
  },
  "billing.sbp.expired": {
    ru: "Время оплаты истекло. Попробуйте оформить платёж снова.",
    en: "The payment window has expired. Please start the payment again.",
  },
  "billing.sbp.failed": {
    ru: "Оплата не прошла. Деньги не списаны, попробуйте снова.",
    en: "The payment did not go through. Please try again.",
  },
  "billing.product.pro_30d": { ru: "Pro на 30 дней", en: "Pro for 30 days" },
  "billing.error.channel_disabled": {
    ru: "Оплата через СБП сейчас недоступна.",
    en: "Payment by SBP is not available right now.",
  },
  "billing.error.channel_unavailable": {
    ru: "Этот товар нельзя оплатить через СБП.",
    en: "This item cannot be paid for by SBP.",
  },
  "billing.error.already_pro": {
    ru: "Pro уже подключён.",
    en: "Pro is already active.",
  },
  "billing.error.checkout_in_progress": {
    ru: "Оплата уже оформляется. Подождите немного и попробуйте снова.",
    en: "A payment is already being set up. Wait a moment and try again.",
  },
  "billing.error.checkout_intent_conflict": {
    ru: "Уже есть незавершённая оплата другого товара. Завершите её или подождите, пока она истечёт.",
    en: "There is an unfinished payment for another item. Finish it or wait for it to expire.",
  },
  "billing.error.product_not_offered": {
    ru: "Этот товар сейчас недоступен для оплаты через СБП.",
    en: "This item is not currently offered for payment by SBP.",
  },
  "billing.error.billing_disabled": {
    ru: "Оплата в этой среде выключена.",
    en: "Payments are switched off in this environment.",
  },
} as const;
